<template>
	<div class="verfahrenzettel">
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<span v-bind="attrs" v-on="on">
					<v-btn 
						icon
						v-if="verfahrenid!=''"
						label="Verfahrenszettel"
						@click="verfahrenDetailsHolen(verfahrenid)"

					>
						<v-icon color="primary">mdi-file-pdf-outline</v-icon>
					</v-btn>
				</span>
			</template>
			<span>Verfahren als pdf-Dokument anzeigen</span>
		</v-tooltip>
	</div>
</template>
<script>
	import jsPDF from "jspdf";
	import axios from 'axios';
	export default {
		name: 'Verfahrenzettel',
		props: {
			verfahrenid: String
		},
		methods: {
			async verfahrenDetailsHolen(verfahrenid) {
				try {
					const response = await axios.get('https://www.arbeitsverdichtung.de/api/verfahren/'+verfahrenid);
					const data = await response;
					this.verfahrenDetails = data.data;
					// console.log(this.verfahrenDetails);
					this.verfahrenblatt();
				} catch (error) {
					alert(error);
				}
			},
			verfahrenblatt() {
				const doc = new jsPDF({
					orientation: "portrait",
					unit: "mm",
					format: "a4",
				});
				var fontName = "Helvetica";
				var fontStyle = "normal";
				var fontSize1 = 11;
				var lines;
				var margin = 25;
				var verticalOffset = margin;

				// Blume einfügen
				var canvasIdBlume = 'verfahrendetail_blume1_' + this.verfahrenid;
				var canvasBlume = document.getElementById(canvasIdBlume);
				var imageBlume = canvasBlume.toDataURL('image/png');
				doc.addImage(imageBlume, 'JPEG', 160, 22);

				// Model einfügen
				var canvasIdModell = 'verfahrendetail_modell1_' + this.verfahrenid;
				var canvasModell = document.getElementById(canvasIdModell);
				var imageModell = canvasModell.toDataURL('image/png');
				doc.addImage(imageModell, 'JPEG', 160, 45);

				verticalOffset = 35;

				lines = doc.setFont(fontName, 'bold')
					.setFontSize(16)
					.splitTextToSize(this.verfahrenDetails.titel, 160);
				doc.text(lines, margin, verticalOffset, {align: 'left', lineHeightFactor: 1.25, maxWidth: '160'});
				verticalOffset += ( lines.length + 0.5 ) * ( 16 / 2.835 ) * 1.25;

				lines = doc.setFont(fontName, fontStyle)
					.setFontSize(fontSize1)
					.splitTextToSize(this.verfahrenDetails.autoren, 160);
				doc.text(lines, margin, verticalOffset, {align: 'left', lineHeightFactor: 1.25, maxWidth: '160'});
				verticalOffset += ( lines.length + 2 ) * ( fontSize1 / 2.835 ) * 1.25;

				function textBlock(ueberschrift, text) {
					// Überschrift
					lines = doc.setFont(fontName, 'bold')
						.setFontSize(12)
						.splitTextToSize(ueberschrift, 160);
					doc.text(lines, margin, verticalOffset, {align: 'left', lineHeightFactor: 1.25, maxWidth: '160'});
					verticalOffset += ( lines.length ) * ( 16 / 2.835 ) * 1.25;
					// Textblock
					lines = doc.setFont(fontName, fontStyle)
						.setFontSize(fontSize1)
						.splitTextToSize(text, 160);
					doc.text(lines, margin, verticalOffset, {align: 'left', lineHeightFactor: 1.25, maxWidth: '160'});
					verticalOffset += ( lines.length + 1.5 ) * ( fontSize1 / 2.835 ) * 1.25;
				}

				textBlock('Beschreibung', this.verfahrenDetails.beschreibung);
				textBlock('Format', this.verfahrenDetails.format);
				textBlock('Zielgruppe', this.verfahrenDetails.zielgruppe);
				textBlock('Anwendende', this.verfahrenDetails.anwendende);
				textBlock('Weitere Informationen', this.verfahrenDetails.url);

				// Dokument ausgeben
				doc.save(this.verfahrenid+'.pdf');
			}
		}
	}
</script>
<style scoped>
</style>
